export class Severity
{
  public static readonly DEBUG: string = 'debug';
  public static readonly ERROR: string = 'error';
  public static readonly NOTICE: string = 'notice';
  public static readonly WARNING: string = 'warning';
}
